import {
  BriefcaseMedical,
  CreditCard,
  Home,
  type LucideIcon,
  Settings,
  Ticket,
  User,
  UserCheck,
  Users,
} from 'lucide-react';

export interface SidebarItem {
  title: string;
  url?: string;
  icon: LucideIcon;
  isActive?: boolean;
  items?: {
    title: string;
    url: string;
  }[];
  roles?: string[];
}
export default [
  {
    title: 'Appointments',
    icon: BriefcaseMedical,
    items: [
      {
        title: 'Standard Appointments',
        url: '/appointments/standard',
      },
      {
        title: 'Second Opinion',
        url: '/appointments/second-opinion',
      },
      {
        title: 'HomeCare Appointments',
        url: '/appointments/homecare',
      },
      {
        title: 'B2B Standard',
        url: '/appointments/b2b-standard',
      },
      {
        title: 'B2B Second Opinion',
        url: '/appointments/b2b-second-opinion',
      },
      {
        title: '3D Printing Requests',
        url: '/appointments/printing-requests',
      },
    ],
  },
  {
    title: 'Patients',
    icon: User,
    items: [
      {
        title: 'All Patients',
        url: '/patients',
      },
      {
        title: 'B2B Patients',
        url: '/patients/B2B',
      },
    ],
  },
  {
    title: 'Doctors',
    icon: Users,
    items: [
      {
        title: 'All Doctors',
        url: '/doctors',
      },
      {
        title: 'Specialities',
        url: '/specialities',
      },
    ],
  },
  {
    title: 'HomeCare',
    icon: Home,
    items: [
      {
        title: 'Clinic',
        url: '/homecare/clinic',
      },
      {
        title: 'Individual',
        url: '/homecare/individual',
      },
    ],
  },
  {
    title: 'Payments',
    icon: CreditCard,
    items: [
      {
        title: 'Standard Payments',
        url: '/payments/standard',
      },
      {
        title: 'Second Opinion Payments',
        url: '/payments/second-opinion',
      },
      {
        title: 'HomeCare Payments',
        url: '/payments/homecare',
      },
    ],
  },
  {
    title: 'Coordinators',
    icon: UserCheck,
    items: [
      {
        title: 'All Coordinators',
        url: '/coordinators',
      },
    ],
    roles: ['super_mc'],
  },
  {
    title: 'Promo Codes',
    icon: Ticket,
    url: '/promo-codes',
    items: [],
  },
  {
    title: 'Settings',
    icon: Settings,
    url: '/settings',
    items: [],
  },
] satisfies SidebarItem[];
